import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getTickerDashboard } from '../../services/api';
import StandardLoader from '../StandardLoader';
import TickerDashboardGrid from './TickerDashboardGrid';
import { trackTickerAccess } from '../../utils/tickerHistory';

function TickerDashboard() {
  const { ticker } = useParams();
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadTickerDashboard();
  }, [ticker]);

  const loadTickerDashboard = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await getTickerDashboard(ticker);
      setDashboardData(response.data);

      // Track ticker access for recent tickers bar
      trackTickerAccess(ticker, 'dashboard');
    } catch (err) {
      console.error('Error loading ticker dashboard:', err);
      setError('Failed to load dashboard for ' + ticker);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <StandardLoader />;

  if (error) {
    return (
      <div className="p-8 text-center">
        <div className="text-red-500 mb-4">{error}</div>
        <Link to="/" className="text-primary hover:underline">
          ← Back to Screener
        </Link>
      </div>
    );
  }

  if (!dashboardData) {
    return (
      <div className="p-8 text-center">
        <div className="text-gray-400 mb-4">No dashboard data available</div>
        <Link to="/" className="text-primary hover:underline">
          ← Back to Screener
        </Link>
      </div>
    );
  }

  return (
    <div className="ticker-dashboard">
      <div className="bg-background border-b border-muted p-4 mb-4">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold text-primary">{ticker} Analysis</h1>
            <p className="text-sm text-gray-400 mt-1">
              Viewing {dashboardData.widgets?.length || 0} widgets
              {dashboardData.widgets?.some(w => w.use_dynamic_ticker) && (
                <span className="ml-2 text-blue-400">
                  • {dashboardData.widgets.filter(w => w.use_dynamic_ticker).length} dynamic
                </span>
              )}
            </p>
          </div>

          <div className="flex gap-3">
            <Link
              to="/dashboard-builder"
              className="bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded transition text-sm flex items-center gap-2"
            >
              ⚙️ Edit Template
            </Link>

            <Link
              to="/"
              className="bg-muted hover:bg-muted/80 text-text px-4 py-2 rounded transition text-sm"
            >
              ← Back to Screener
            </Link>

            <Link
              to="/watchlist"
              className="bg-muted hover:bg-muted/80 text-text px-4 py-2 rounded transition text-sm"
            >
              Watchlist
            </Link>
          </div>
        </div>
      </div>

      <TickerDashboardGrid dashboardData={dashboardData} ticker={ticker} />
    </div>
  );
}

export default TickerDashboard;
